module.exports = __webpack_public_path__ + "img/addTask.102cb9aa.svg";